import { ImportersApi } from 'src/orchd-client';

import { axiosInstance } from 'src/utils/axios';

export const importersApi = ImportersApi({}, '/api', axiosInstance);
